import React, { useState, useEffect, useRef } from 'react';
import { TABLET_WIDTH } from '../../globalUtils';
import {
    Container, TopText, WhiteArea, InsuranceTypes, InsuranceInfo, Shield, TypesText,
    Types, Type, LightBulb, InfoTitle, InfoText, InfoCtaText, InfoCta,
} from './RisksSaving.style';

const getInsuranceTypes = (content) => {
    return Object.keys(content)
        .filter(k => k.indexOf('ins') !== -1)
        .map(k => content[k]);
};

const RisksSaving = ({ setFormActive, content }) => {
    const insuranceTypes = getInsuranceTypes(content);
    const [current, setCurrent] = useState(0);
    const containerEl = useRef(null);
    const infoEl = useRef(null);
    const { text, listTitle } = content;
    const currentType = insuranceTypes[current];

    useEffect(() => {
        setCurrent(0);
    }, [content]);

    return <Container ref={containerEl}>
        <TopText>{!!text && text.text}</TopText>
        <WhiteArea>
            <InsuranceTypes>
                <Shield />
                <TypesText>{!!listTitle && listTitle.text}</TypesText>
                <Types>{insuranceTypes
                    .map(({ title }, i) => <Type
                        key={`it-${i}`}
                        onClick={() => {
                            setCurrent(i);
                            const { current: { clientWidth } } = containerEl;
                            if (clientWidth < TABLET_WIDTH) {
                                infoEl.current.scrollIntoView({
                                    behavior: 'smooth',
                                    block: 'center',
                                });
                            }
                        }}
                        current={i === current}
                    >{!!title && title.text}</Type>)}</Types>
            </InsuranceTypes>
            <InsuranceInfo ref={infoEl}>
                <LightBulb />
                <InfoTitle>{!!currentType.title && currentType.title.text}</InfoTitle>
                <InfoText>{!!currentType.text && currentType.text.text}</InfoText>
                <InfoCtaText>{!!currentType.ctatext && currentType.ctatext.text}</InfoCtaText>
                <InfoCta onClick={() => setFormActive(true)}>{!!content.cta && content.cta.text}</InfoCta>
            </InsuranceInfo>
        </WhiteArea>
    </Container>;
};

export default RisksSaving;